export default {
  isEnabled: state => state.isEnabled,
  selectedItems: state => state.selectedItems,
  selectedItemsCount: state => state.selectedItems.length,
};
